<template>
<v-dialog v-model="dialog" max-width="980px" scrollable persistent :fullscreen="$vuetify.breakpoint.smAndDown">
    <v-card>
        <v-card-title>
            <v-icon class="pr-2" color="primary">view_module</v-icon>
            <div class="pt-3">{{ $t('sheet.pricing_modal.tittle') }}</div>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
            <div class="">
                <div class="">
                    <span class="title pr-2">{{ $t('sheet.pricing_modal.apply') }}</span>
                    <span class="subheading">{{ $t('sheet.pricing_modal.message.room_selection') }}</span>
                </div>
                <v-row class="">
                    <template v-for="room in room_types">
                        <v-col v-if="!room.close_out" md="6" cols="12" :key="room.id">
                            <room :room="room" :net_price="net_price" @change="updatePricing($event)" ref="room" />
                        </v-col>
                    </template>
                </v-row>
            </div>
            <v-divider></v-divider>
            <div class="py-2">
                <div class="">
                    <span class="title pr-2">{{ $t('sheet.pricing_modal.valibility_and_weekdays') }}</span>
                    <span class="subheading">{{ $t('sheet.pricing_modal.message.past_days') }}</span>
                </div>
                <div class="d-flex">
                    <v-menu transition="scale-transition" offset-y min-width="max-content">
                        <template v-slot:activator="{ on }">
                            <v-text-field v-on="on" v-model="period.start" :label="$t('sheet.pricing_modal.start_date')" prepend-icon="event" readonly></v-text-field>
                        </template>
                        <v-date-picker v-model="period.start" :min="today" no-title width="265">
                            <v-spacer></v-spacer>
                            <v-btn text color="red" @click="period.start = null;">{{ $t('button.clear_date') }}</v-btn>
                        </v-date-picker>
                    </v-menu>
                    <v-menu transition="scale-transition" offset-y min-width="max-content">
                        <template v-slot:activator="{ on }">
                            <v-text-field v-on="on" v-model="period.stop" :label="$t('sheet.pricing_modal.end_date')" prepend-icon="arrow_right_alt" readonly></v-text-field>
                        </template>
                        <v-date-picker v-model="period.stop" :min="minPeriodDate()" no-title max-width="265">
                            <v-spacer></v-spacer>
                            <v-btn text color="red" @click="period.stop = null;">{{ $t('button.clear_date') }}</v-btn>
                        </v-date-picker>
                    </v-menu>
                </div>
                <v-row>
                    <v-btn v-for="(day,index) in days" :key="index" small rounded depressed class="weekend-days regular mx-1" :color="weekdays.includes(day.value) ? 'primary' : 'grey lighten-2'" @click="selectDays(day.value)">
                        <span class="text-capitalize">{{ $t('week_days_short.' + day.text) }}</span>
                    </v-btn>
                </v-row>
            </div>
            <v-divider></v-divider>
            <div class="py-2">
                <div class="">
                    <span class="title pr-2">{{ $t('sheet.pricing_modal.disponibility_and_restrictions') }}</span>
                    <span class="subheading">{{ $t('sheet.pricing_modal.message.pricing_and_restrictions') }}</span>
                </div>
                <v-row>
                    <v-col class="py-0" md="6" cols="12">
                        <div class="justify-center d-flex py-1">
                            <v-btn :small="$vuetify.breakpoint.smAndDown" color="primary" :outlined="!availability" @click="availability=!availability">{{ $t('sheet.pricing_modal.disponibility') }}</v-btn>
                        </div>
                        <div>
                            <v-text-field :label="$t('sheet.pricing_modal.price')" v-model="price_rate_plan" class="pr-5" :disabled='!availability' :suffix="currency"></v-text-field>
                        </div>
                        <div class="py-2 justify-space-around d-flex">
                            <v-btn :small="$vuetify.breakpoint.smAndDown" :outlined="!start_sell" color="green" :disabled='!availability' @click="startSell()">{{ $t('sheet.pricing_modal.sell') }}</v-btn>
                            <v-btn :small="$vuetify.breakpoint.smAndDown" :outlined="!stop_sell" color="red" :disabled='!availability' @click="stopSell()">{{ $t('sheet.pricing_modal.stop_sell') }}</v-btn>
                        </div>
                    </v-col>
                    <v-col class="py-0" md="6" cols="12">
                        <div class="justify-center d-flex py-1">
                            <v-btn :small="$vuetify.breakpoint.smAndDown" color="primary" :outlined="!restrictions" @click="restrictions=!restrictions">{{ $t('sheet.pricing_modal.restrictions') }}</v-btn>
                        </div>
                        <v-row no-gutters>
                            <v-col cols="6">
                                <v-text-field v-model="min_stay" :label="$t('sheet.pricing_modal.min_stay')" class="px-2" :disabled='!restrictions'></v-text-field>
                            </v-col>
                            <v-col cols="6">
                                <v-text-field v-model="max_stay" :label="$t('sheet.pricing_modal.max_stay')" class="px-2" :disabled='!restrictions'></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row v-if="admin" no-gutters>
                            <v-col cols="6">
                                <v-menu transition="scale-transition" offset-y :disabled='!restrictions'>
                                    <template v-slot:activator="{ on }">
                                        <v-text-field class="px-2" v-on="on" v-model="min_booking_date" :label="$t('sheet.pricing_modal.min_booking_date')" prepend-icon="event" readonly :disabled='!restrictions'></v-text-field>
                                    </template>
                                    <v-date-picker v-model="min_booking_date" :min="today" no-title max-width="265">
                                        <v-spacer></v-spacer>
                                        <v-btn text color="red" @click="min_booking_date = null;">{{ $t('button.clear_date') }}</v-btn>
                                    </v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col cols="6">
                                <v-menu transition="scale-transition" offset-y :disabled='!restrictions'>
                                    <template v-slot:activator="{ on }">
                                        <v-text-field class="px-2" v-on="on" v-model="max_booking_date" :label="$t('sheet.pricing_modal.max_booking_date')" :disabled='!restrictions' prepend-icon="event" readonly></v-text-field>
                                    </template>
                                    <v-date-picker v-model="max_booking_date" :min="today" no-title max-width="265">
                                        <v-spacer></v-spacer>
                                        <v-btn text color="red" @click="max_booking_date = null;">{{ $t('button.clear_date') }}</v-btn>
                                    </v-date-picker>
                                </v-menu>
                            </v-col>
                        </v-row>
                        <div class="justify-space-around d-flex px-2">
                            <v-btn class="px-1" :small="$vuetify.breakpoint.smAndDown" :color="status_arrival?'green':'red'" :outlined='!save_item.status_arrival' :disabled='!restrictions' @click="status_arrival=!status_arrival,save_item.status_arrival= true">
                                <span v-if="status_arrival">{{ $t('sheet.pricing_modal.open_arrival') }}</span>
                                <span v-else>{{ $t('sheet.pricing_modal.closed_arrival') }}</span>
                            </v-btn>
                            <v-btn class="px-1" :small="$vuetify.breakpoint.smAndDown" :color="status_departure?'green':'red'" :outlined='!save_item.status_departure' :disabled='!restrictions' @click="status_departure=!status_departure,save_item.status_departure= true">
                                <span v-if="status_departure">{{ $t('sheet.pricing_modal.open_departure') }}</span>
                                <span v-else>{{ $t('sheet.pricing_modal.closed_departure') }}</span>
                            </v-btn>
                        </div>
                    </v-col>
                </v-row>
            </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="emitExit">
                {{ $t('button.cancel') }}
            </v-btn>
            <v-btn color="primary" :loading="loading" :disabled="!save_status" @click="save">
                {{ $t('button.update') }}
            </v-btn>
        </v-card-actions>
    </v-card>
</v-dialog>
</template>

<script>
import {
    mapActions
} from 'vuex';
import logger from '../../../logger.js';

import Room from './PricingRatePlan.vue';

export default {
    name: `pricing-card`,
    components: {
        'room': Room
    },

    props: {
        admin: {
            type: Boolean,
            default: false
        },
        hotel_id: Number,
        room_types: Array,
        dialog: Boolean,
        net_price: Boolean,
        currency: String,
        date_period: {
            type: Object,
            default () {
                return {
                    start: null,
                    stop: null
                }
            }
        }
    },
    data() {
        return {
            period: {
                start: this.date_period.start,
                stop: this.date_period.stop
            },

            today: new Date()
                .toISOString()
                .substr(0, 10),

            rate_plans_selected: false,
            availability: false,
            restrictions: false,
            price_rate_plan: null,
            min_stay: null,
            max_stay: null,
            min_booking_date: null,
            max_booking_date: null,
            start_sell: false,
            stop_sell: false,
            status_arrival: true,
            status_departure: true,
            color_arrival: "green",
            color_departure: "green",
            loading: false,
            save_item: {
                status_arrival: false,
                status_departure: false,
            },

            rooms: [],
            rate_plans: [],
            weekdays: [0, 1, 2, 3, 4, 5, 6],
            pricing: {},
            days: [{
                    text: "monday",
                    value: 1
                }, {
                    text: "tuesday",
                    value: 2
                }, {
                    text: "wednesday",
                    value: 3
                }, {
                    text: "thursday",
                    value: 4
                }, {
                    text: "friday",
                    value: 5
                }, {
                    text: "saturday",
                    value: 6
                }, {
                    text: "sunday",
                    value: 0
                }
            ],
        }
    },
    watch: {
        // reset to default values
        dialog: {
            handler(old) {
                if(old == false) {
                    this.period = {
                        'start': this.date_period.start,
                        'stop': this.date_period.stop
                    };
                    this.min_booking_date = null;
                    this.max_booking_date = null;
                    this.price_rate_plan = null;
                    this.availability = false;
                    this.restrictions = false;
                    this.stop_sell = false;
                    this.start_sell = false;
                    this.save_item.status_arrival = false;
                    this.save_item.status_departure = false;
                    this.status_arrival = true;
                    this.status_departure = true;
                    this.min_stay = null;
                    this.max_stay = null;
                    this.rooms = [];
                    this.rate_plans_selected = false;
                    this.rate_plans = [];
                    this.pricing = {};
                    this.weekdays = [0, 1, 2, 3, 4, 5, 6];
                    this.$refs.room.forEach(function (item) {
                        item.clean();
                    })
                }
            }
        },

        date_period: {
            handler() {
                this.period = {
                    'start': this.date_period.start,
                    'stop': this.date_period.stop
                };
            }
        },

        'period.start'(newVal) {
            let value = this.$moment(this.period.start)
                .isBefore(this.period.stop)
            if(!value) {
                this.period.stop = null;
            }
        }

    },

    computed: {
        save_status() {
            return (this.availability || this.restrictions) && this.rate_plans_selected && (this.period.start !== null && this.period.stop !== null)
        },
    },

    methods: {
        ...mapActions('alert', ['success', 'error']),

        save() {
            this.loading = true;
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/console/v1/pricing/bulk-update';

            // setup query params
            let params = {};
            if(this.availability) {
                if(!!this.price_rate_plan) {
                    params.price = this.price_rate_plan;
                }
                switch (true) {
                case this.start_sell:
                    params.stop_sell = false;
                    break;
                case this.stop_sell:
                    params.stop_sell = true;
                    break;
                }
            }
            if(this.restrictions) {
                if(!!this.min_stay) {
                    params.min_stay = Number(this.min_stay);
                }
                if(!!this.max_stay) {
                    params.max_stay = Number(this.max_stay);
                }
                if(!!this.min_booking_date) {
                    params.min_booking_date = this.min_booking_date;
                }
                if(!!this.max_booking_date) {
                    params.max_booking_date = this.max_booking_date;
                }
                if(this.save_item.status_arrival) {
                    params.closed_arrival = !this.status_arrival;
                }
                if(this.save_item.status_departure) {
                    params.closed_departure = !this.status_departure;
                }
            }

            params.hotel_id = this.hotel_id;
            params.date_start = this.period.start;
            params.date_stop = this.period.stop;
            params.pricing = this.pricing;
            params.weekdays = this.weekdays;

            this.$axios.post(endpoint, params)
                .then(response => {
                    this.success(this.$t('sheet.pricing_modal.message_updated'));
                    this.emitExit();
                    this.$emit('refresh');
                })
                .catch(error => {
                    this.error('Ooops, something gone wrong');
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        updatePricing(value) {
            let room_id = value[0];
            let rate_plans = value[1];
            this.pricing[room_id] = rate_plans;
            if(rate_plans.length == 0) {
                delete this.pricing[room_id];
            }
            this.rate_plans_selected = Object.keys(this.pricing)
                .length > 0;
        },

        minPeriodDate() {
            if(this.period.start) {
                let date = this.$moment(this.period.start, "YYYY-MM-DD")
                    .add(1, 'day')
                    .format("YYYY-MM-DD");

                return date
            } else {
                let date = this.$moment(this.today, "YYYY-MM-DD")
                    .add(1, 'day')
                    .format("YYYY-MM-DD");
                return date
            }
        },

        selectDays(value) {
            if(this.weekdays.includes(value)) {
                let index = this.weekdays.indexOf(value);
                if(index > -1) {
                    this.weekdays.splice(index, 1);
                }
            } else {
                this.weekdays.push(value)
            }
        },

        startSell() {
            this.stop_sell = false;
            this.start_sell = !this.start_sell;
        },

        stopSell() {
            this.start_sell = false;
            this.stop_sell = !this.stop_sell;
        },

        emitExit() {
            this.$emit('close');
            this.period = {
                'start': this.date_period.start,
                'stop': this.date_period.stop
            };
            this.min_booking_date = null;
            this.max_booking_date = null;
            this.price_rate_plan = null;
            this.availability = false;
            this.restrictions = false;
            this.stop_sell = false;
            this.start_sell = false;
            this.save_item.status_arrival = false;
            this.save_item.status_departure = false;
            this.status_arrival = true;
            this.status_departure = true;
            this.min_stay = null;
            this.max_stay = null;
            this.rooms = [];
            this.rate_plans_selected = false;
            this.rate_plans = [];
            this.pricing = {};
            this.weekdays = [0, 1, 2, 3, 4, 5, 6];
            this.$refs.room.forEach(function (item) {
                item.clean();
            })
        }
    }
}
</script>
<style lang="stylus">
.weekend-days
    &.v-btn
        min-width: 55px
</style>
